var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-test purchase__testimonials"},[_c('div',[_c('stars',{attrs:{"value":_vm.rating}}),_vm._v(" "),_c('span',{staticClass:"h6 text-secondary mb-0"},[_vm._v("\n      "+_vm._s(_vm.rating)+"\n    ")])],1),_vm._v(" "),(_vm.hasBlock)?_c('a',{staticClass:"link-cta",attrs:{"href":"#testimonials"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('testimonials')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('testimonial.see', {
        number: _vm.numberOf,
      })))])]):_c('span',{staticClass:"link-cta"},[_vm._v("\n    "+_vm._s(_vm.$t('testimonial.based_on_number', {
        number: _vm.numberOf,
      }))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }